import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { HTTP_STATUS } from "../../http/constants/http.status";
import { AppConstants } from "../../constants/AppConstants";
import { useTheme } from "../../context/themeContext";
import Modal from "../shared/ModalPortal/Modal";

import LoaderContainer from "../shared/loaderContainer/LoaderContainer";

interface ModalProps {
  visibility: boolean;
  setVisibility: Function;
}

const DisclaimerInfo = ({ visibility, setVisibility }: ModalProps) => {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(AppConstants.LOCALISATION_NAMESPACE_DISCLAIMER);
  const theme = useTheme().theme;

  const contents: Array<any> =
    t("T_DISCLAIMER_BODY", { returnObjects: true }) || [];
  return (
    <Modal
      overflowVisible={false}
      showCloseIcon
      width="85rem"
      showHeader
      headerText={t("T_DISCLAIMER_TITLE")}
      headerStyles="!md:text-3xl !text-2xl"
      toggleVisiblity={(value: boolean) => {
        setVisibility(value);
      }}
      isVisible={visibility}
      containerBackgroundColor={theme.secondary2}
      headerBackgroundColor={theme.whiteAppColor}
      primaryButtonText={t("T_DISCLAIMER_BUTTON") || t("T_CLOSE")}
      primaryOnClick={() => {
        setVisibility(false);
      }}
      customHeaderComponent={<></>}
      body={
        <LoaderContainer isLoading={false}>
          <div className="w-full rounded-lg">
            <ul className="list-disc pl-5">
              {contents?.map((point: any = "", index: any) => (
                <li
                  key={index}
                  className="mb-4 text-base sm:text-lg md:text-xl"
                >
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </LoaderContainer>
      }
    />
  );
};

export default DisclaimerInfo;
